webpackJsonp([189721678517738],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\nmargin: 0 auto;\nmax-width: ', ';\npadding: ', ';\n@media (max-width: ', ') {\n  max-width: 95vw;\n}\n'], ['\nmargin: 0 auto;\nmax-width: ', ';\npadding: ', ';\n@media (max-width: ', ') {\n  max-width: 95vw;\n}\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BodyContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.widthLaptop;
	});
	
	var CommunityPage = function (_React$Component) {
	  _inherits(CommunityPage, _React$Component);
	
	  function CommunityPage() {
	    _classCallCheck(this, CommunityPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CommunityPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'index-container' },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(_Header2.default, {
	          language: 'en_uk',
	          siteTitle: _SiteConfig2.default.siteTitle,
	          siteDescription: _SiteConfig2.default.siteDescription,
	          location: this.props.location,
	          logo: _SiteConfig2.default.siteLogo
	        }),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Community'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Nact is developed in the open. Development activities are hosted on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/ncthbrt/nact' },
	              'github'
	            ),
	            '. If you have any questions, or just want to say \u201CHi!\u201D, please visit the discord below: '
	          ),
	          _react2.default.createElement('iframe', { src: 'https://discordapp.com/widget?id=392625718682714112&theme=light', width: '350', height: '500', allowTransparency: 'true', frameBorder: '0' })
	        )
	      )
	    );
	  };
	
	  return CommunityPage;
	}(_react2.default.Component);
	
	exports.default = CommunityPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-uk-community-jsx-aa77b6185bea4450dcf3.js